import React from  'react';
import DoneButton from '../Crossword/DoneButton/DoneButton';

const seeSolutionButton = (props) => {
  if (props.isLoggedIn) {
    return (
      <DoneButton
        classes={['crosswordSeeSolutionButton']}
        active={props.active}
        buttonClicked={props.buttonClicked}>
        See Solution
      </DoneButton>
    );
  } else {
    return null;
  }
};

export default seeSolutionButton;
